import React from 'react'

const SearchNoResults = ({
  title = '',
  message = '',
  className = '',
  bigButton = false
} = {}) => {
  const buttonClass = bigButton
    ? 'mt-2 pt-2.5 pb-2.5'
    : 'h-[34px] pt-1.5 pb-1.5'

  const titleMarginClass = bigButton ? 'mb-2' : 'mb-1'
  return (
    <div
      className={`flex pd:mt-0 pr-[16px] pl-[16px] justify-center w-full h-full ${className}`}
    >
      <div className="flex flex-col text-center place-items-center">
        <span
          className={`text-base font-medium text-gray-1100 ${titleMarginClass}`}
        >
          {title}
        </span>
        <span className="text-gray-800 w-[233px] h-[40px] mb-4 ">
          {message}
        </span>
        <a
          href="/browse"
          className={`inline-block rounded-lg border border-solid border-gray-400 text-sm text-gray-900 pr-4 pl-4 ${buttonClass}`}
        >
          Browse All Locations
        </a>
      </div>
    </div>
  )
}
export default SearchNoResults
